import * as React from 'react';
import {
  ChatBubble,
  ChatAnchor,
  ChatContent,
  ChatBody,
  CHAT_BUBBLE_ORIENTATION,
} from '@spaced-out/ui-design-system';
import {getThinkingTexts} from '../ask-ai-store';
import css from './thinking-widget.css';

//TODO:(diwakersurya) revisit this when backend starts sending the thinking texts
type ThinkingWidgetProps = {
  interval: number;
};
export const ThinkingWidget = ({interval}: ThinkingWidgetProps) => {
  const texts = getThinkingTexts();
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [isPending, startTransition] = React.useTransition();

  React.useEffect(() => {
    if (currentIndex >= texts.length - 1) {
      return;
    }
    const timerId = setInterval(() => {
      startTransition(() => {
        setCurrentIndex((prevIndex) => {
          // Stop advancing when reaching the last text
          if (prevIndex >= texts.length - 1) {
            return prevIndex;
          }
          return prevIndex + 1;
        });
      });
    }, interval);
    return () => clearInterval(timerId);
  }, [texts, currentIndex, interval]);

  const thinkingText = texts[currentIndex];

  return (
    <ChatBubble orientation={CHAT_BUBBLE_ORIENTATION.left}>
      <ChatAnchor />
      <ChatContent classNames={{wrapper: css.chatContentWrapper}}>
        <ChatBody isLoading loadingText={thinkingText}></ChatBody>
      </ChatContent>
    </ChatBubble>
  );
};
